import React from "react";

const HeroIcon = () => {
  return (
    <>
      <svg
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_3088_27414)">
          <g clipPath="url(#clip1_3088_27414)">
            <g clipPath="url(#clip2_3088_27414)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.548809 21.7253C0.548809 33.7242 10.2758 43.4512 22.2741 43.4512C34.2736 43.4512 44 33.7242 44 21.7259C44 9.72638 34.273 0 22.2747 0C10.2758 0 0.548809 9.72697 0.548809 21.7253ZM24.5288 37.7139C22.1599 35.6882 20.6848 32.8347 20.6848 29.6732C20.6848 23.5275 26.2597 18.546 33.1374 18.546C34.8676 18.546 36.5146 18.8611 38.013 19.4308C36.8423 11.7302 30.1935 5.82881 22.1653 5.82881C19.8226 5.82881 17.5982 6.33124 15.5926 7.23384C16.4447 8.14951 16.9745 9.43681 16.9745 10.8626C16.9745 13.643 14.9582 15.8965 12.4704 15.8965C10.8002 15.8965 9.34227 14.8803 8.56454 13.3712C6.97304 15.9154 6.13138 18.8569 6.13622 21.8579C6.13622 30.7108 13.313 37.887 22.1653 37.887C22.968 37.887 23.757 37.8281 24.5282 37.7145L24.5288 37.7139Z"
                fill="white"
              />
              <mask
                id="mask0_3088_27414"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="44"
                height="44"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.548809 21.7253C0.548809 33.7242 10.2758 43.4512 22.2741 43.4512C34.2736 43.4512 44 33.7242 44 21.7259C44 9.72638 34.273 0 22.2747 0C10.2758 0 0.548809 9.72697 0.548809 21.7253ZM24.5288 37.7139C22.1599 35.6882 20.6848 32.8347 20.6848 29.6732C20.6848 23.5275 26.2597 18.546 33.1374 18.546C34.8676 18.546 36.5146 18.8611 38.013 19.4308C36.8423 11.7302 30.1935 5.82881 22.1653 5.82881C19.8226 5.82881 17.5982 6.33124 15.5926 7.23384C16.4447 8.14951 16.9745 9.43681 16.9745 10.8626C16.9745 13.643 14.9582 15.8965 12.4704 15.8965C10.8002 15.8965 9.34227 14.8803 8.56454 13.3712C6.97304 15.9154 6.13138 18.8569 6.13622 21.8579C6.13622 30.7108 13.313 37.887 22.1653 37.887C22.968 37.887 23.757 37.8281 24.5282 37.7145L24.5288 37.7139Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_3088_27414)">
                <path
                  d="M24.5281 37.7139L24.76 39.2866L28.2164 38.7765L25.5615 36.5057L24.5281 37.7139ZM38.0117 19.4313L37.4469 20.9172L39.9923 21.8864L39.5832 19.1929L38.0117 19.4313ZM15.5925 7.23383L14.9397 5.78421L12.9187 6.69394L14.4289 8.31718L15.5925 7.23383ZM8.56444 13.3712L9.97779 12.6429L8.69822 10.1592L7.21649 12.5281L8.56444 13.3712ZM22.2734 41.8612C11.1527 41.8612 2.13806 32.846 2.13806 21.7253H-1.04124C-1.04124 34.6024 9.39687 45.0411 22.274 45.0411V41.8612H22.2734ZM42.41 21.7253C42.41 32.8466 33.3947 41.8612 22.274 41.8612L22.2746 45.0405C35.1511 45.0405 45.5898 34.6024 45.5898 21.7253H42.41ZM22.274 1.59054C33.3947 1.59054 42.4094 10.6052 42.4094 21.7259H45.5892C45.5892 8.84935 35.1505 -1.58936 22.274 -1.58936V1.59054ZM2.13806 21.7259C2.13806 10.6052 11.1533 1.59054 22.274 1.59054V-1.58936C9.39687 -1.58936 -1.04183 8.84935 -1.04183 21.7259H2.13806ZM19.0941 29.6738C19.0941 33.3514 20.8143 36.6306 23.4953 38.9227L25.5615 36.5069C23.5042 34.7475 22.2734 32.3192 22.2734 29.6738H19.0941ZM33.1367 16.9561C25.5538 16.9561 19.0941 22.487 19.0941 29.6738H22.2734C22.2734 24.5698 26.9648 20.1359 33.1367 20.1359V16.9561ZM38.5772 17.9455C36.8389 17.2876 34.9952 16.9524 33.1367 16.9561V20.1353C34.6731 20.1353 36.1292 20.4154 37.4463 20.9166L38.5772 17.9455ZM22.1658 7.41816C29.3961 7.41816 35.3872 12.7338 36.4408 19.6698L39.5838 19.1923C38.2977 10.7259 30.9902 4.23886 22.1658 4.23886V7.41816ZM16.2454 8.68346C18.1067 7.84642 20.1249 7.4151 22.1658 7.41816V4.23946C19.5942 4.23946 17.1474 4.79124 14.9403 5.7854L16.2454 8.68346ZM18.5643 10.8626C18.5643 9.04319 17.8883 7.36702 16.7568 6.15108L14.4289 8.31718C15.0015 8.93318 15.3856 9.83043 15.3856 10.8626H18.5643ZM12.4709 17.4864C15.9981 17.4864 18.5643 14.3499 18.5643 10.8626H15.3856C15.3856 12.936 13.9194 14.3071 12.4709 14.3071V17.4864ZM7.15228 14.099C8.16011 16.0552 10.1187 17.4864 12.4709 17.4864V14.3071C11.4827 14.3071 10.5248 13.7048 9.97779 12.6429L7.15228 14.099ZM7.72606 21.8579C7.72134 19.1549 8.47935 16.5053 9.91298 14.2138L7.21649 12.5281C5.46707 15.3252 4.54235 18.5588 4.54736 21.8579H7.72606ZM22.1658 36.2976C14.1911 36.2976 7.72606 29.8326 7.72606 21.8579H4.54736C4.54736 31.5884 12.4352 39.4769 22.1658 39.4769V36.2976ZM24.2962 36.1412C23.5909 36.2456 22.8788 36.2978 22.1658 36.2976V39.4769C23.0464 39.4769 23.9133 39.4115 24.7612 39.2866L24.2962 36.1412Z"
                  fill="white"
                />
              </g>
            </g>
          </g>
        </g>
        <defs>
          <clipPath id="clip0_3088_27414">
            <rect
              width="44"
              height="44"
              fill="white"
              transform="matrix(0 1 -1 0 44 0)"
            />
          </clipPath>
          <clipPath id="clip1_3088_27414">
            <rect
              width="44"
              height="44"
              fill="white"
              transform="matrix(0 1 -1 0 44 0)"
            />
          </clipPath>
          <clipPath id="clip2_3088_27414">
            <rect
              width="44"
              height="44"
              fill="white"
              transform="matrix(0 1 -1 0 44 0)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default HeroIcon;
